function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 24.7,
  fill: "#999",
  width: 19.1,
  height: 6.1
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.1,
  y: 21.6,
  fill: "#999",
  width: 10,
  height: 6.1
});

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  fill: "#F26739",
  points: "34.1,40.3 31.3,30.4 36.3,22.5 53.7,15.8 54.2,29.1 45.8,39.9 "
});

var _ref5 = /*#__PURE__*/React.createElement("polyline", {
  fill: "#FFF",
  points: "28,37.8 22.4,26.9 26.9,14.9 38.8,3.4 46.8,2.1 52,4.3 59.1,3.7 55.3,9.8 61.5,13.1 55,15.8 40.1,20  31.8,29.6 32.7,39.9  "
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7,43.2c-9.8,0-17.7-8-17.7-17.7c0-4.6,3.3-10.8,8.7-16.4C35.2,3.4,41.2,0,45.8,0c10.7,0,10.7,16.6,10.7,25.5 C56.4,35.2,48.4,43.2,38.7,43.2z M45.7,3.4c-7.8,0-21.3,14-21.3,22c0,7.9,6.4,14.2,14.2,14.2s14.2-6.4,14.2-14.2 C52.9,17.7,52.9,3.4,45.7,3.4z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54,11.6c-0.5,0-1-0.2-1.3-0.6c-0.6-0.7-0.6-1.8,0.2-2.5L55.7,6l-3.4,0.7c-0.9,0.2-1.9-0.4-2.1-1.4 c-0.2-0.9,0.4-1.9,1.4-2.1l9.8-2C62.2,1,63,1.4,63.3,2.1c0.4,0.7,0.2,1.6-0.4,2.1L55.2,11C54.8,11.5,54.4,11.6,54,11.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M54.7,17.5c-0.8,0-1.6-0.6-1.7-1.5c-0.2-1,0.5-1.9,1.4-2l3.6-0.6L54,12c-0.9-0.3-1.4-1.3-1.1-2.2c0.3-0.9,1.3-1.4,2.2-1.1 l10.2,3.7c0.7,0.3,1.2,1,1.1,1.8s-0.7,1.4-1.4,1.6l-10.1,1.7C54.9,17.5,54.8,17.5,54.7,17.5z"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 42.8,
  cy: 7.9,
  r: 1.9
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1,42.6c-0.6,0-1.2-0.3-1.5-0.9c-0.3-0.4-6.5-10.9,0.3-18.1s20.9-9.5,21.5-9.6c1-0.2,1.9,0.5,2,1.5c0.2,1-0.5,1.9-1.5,2 c-0.1,0-13.5,2.2-19.5,8.6c-5,5.3,0,13.8,0.1,13.9c0.5,0.8,0.2,1.9-0.6,2.4C34.7,42.5,34.4,42.6,34.1,42.6z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M3.6,32.9c-0.4,0-0.8-0.2-1.2-0.4c-0.2-0.2-2.2-2.1-2.4-5.9s2.7-7.2,2.8-7.4c0.5-0.5,1.2-0.7,1.9-0.5l18.2,5.9 c0.9,0.3,1.4,1.3,1.1,2.2c-0.3,0.9-1.3,1.4-2.2,1.1l-17-5.6c-0.7,1-1.4,2.6-1.3,4c0.1,1.5,0.6,2.4,0.9,3l18.3-0.9 c1-0.1,1.8,0.7,1.8,1.7s-0.7,1.8-1.7,1.8L3.6,32.9C3.7,32.9,3.6,32.9,3.6,32.9z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M43,59.3c-0.6,0-1.3-0.4-1.6-1l-7.8-15.9c-0.4-0.9-0.1-1.9,0.8-2.3c0.9-0.4,1.9-0.1,2.3,0.8l7.8,15.9 c0.4,0.9,0.1,1.9-0.8,2.3C43.5,59.2,43.2,59.3,43,59.3z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M54.3,59.3c-0.6,0-1.3-0.4-1.6-1l-8.6-17.5c-0.4-0.9-0.1-1.9,0.8-2.3c0.9-0.4,1.9-0.1,2.3,0.8l8.6,17.5 c0.4,0.9,0.1,1.9-0.8,2.3C54.8,59.2,54.5,59.3,54.3,59.3z"
});

var SvgGrumpyRobin = function SvgGrumpyRobin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.4 59.3",
    style: {
      enableBackground: "new 0 0 66.4 59.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrumpyRobin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grumpy-robin.209e19a7.svg";
export { ForwardRef as ReactComponent };